/* eslint-disable sonarjs/no-duplicate-string */

import { CoreConfigTypes } from './types/core-config-types';

export const CoreConfig: CoreConfigTypes = {
    channel: {
        value: '',
    },
};
